import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { CardItem, LpStatisticsCard } from './types';
import { CARD_ITEMS } from './constants';

@Component({
  selector: 'lp-statistics-card',
  templateUrl: './lp-statistics-card.component.html',
  styleUrls: ['./lp-statistics-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpStatisticsCardComponent extends BaseResizableComponent {
  @Input() set cardType(valueType: LpStatisticsCard) {
    this.selectCard = CARD_ITEMS.find(item => item.type === valueType);
  }
  selectCard?: CardItem;

  @Input() count?: number;
}
